import { z } from 'zod';
const slugRegex = /^[a-z0-9-]+$/;
// Only http(s) URLs: blocks javascript:/data: schemes and keeps image URLs safe
// when echoed into JSON-LD / pages (defense in depth alongside output escaping).
const imageUrl = z
    .string()
    .url()
    .max(2000)
    .refine((v) => /^https?:\/\//i.test(v), 'La URL debe empezar por http:// o https://');
// Mirrors the real `blog_posts` table: visibility is the boolean is_published,
// the lead text column is `summary` (exposed to the client as `excerpt`), and
// cover_image_url is a real column. There is no status enum nor opposition_id.
export const createBlogPostSchema = z.object({
    title: z.string().min(1).max(300),
    slug: z.string().min(1).max(200).regex(slugRegex, 'Slug solo permite letras minúsculas, números y guiones').optional(),
    content: z.string().min(1).max(50000),
    excerpt: z.string().max(500).optional(),
    cover_image_url: imageUrl.optional(),
    is_published: z.boolean().default(false),
});
export const updateBlogPostSchema = z.object({
    title: z.string().min(1).max(300).optional(),
    slug: z.string().min(1).max(200).regex(slugRegex, 'Slug solo permite letras minúsculas, números y guiones').optional(),
    content: z.string().min(1).max(50000).optional(),
    excerpt: z.string().max(500).nullable().optional(),
    cover_image_url: imageUrl.nullable().optional(),
    is_published: z.boolean().optional(),
});
//# sourceMappingURL=blog.schema.js.map